import React, { Component } from 'react';

/* 개발담당:양유빈
 * 화면기능:정산관리
 * 세부설명:
*/

export class CostSettleList extends Component {
    static displayName = CostSettleList.name;

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
    } 

    render() {
        return (
            <div>
                <div className="container_box p_margin c_padding">
                    <div className="month_select_Box">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm">
                            <option>2022년 11월</option>
                            <option value="1">2022년 10월</option>
                            <option value="2">2022년 09월</option>
                            <option value="3">2022년 08월</option>
                            <option value="4">2022년 07월</option>
                        </select>
                    </div>
                    {/*<div className="month_cost_box">*/}
                    {/*    <div className="month">2022년 11월 총 주문금액</div>*/}
                    {/*    <div className="txt">주문금액은 미송 등 소매와의 거래 취소로 실제와 다를 수 있습니다.</div>*/}
                    {/*    <div className="total_cost">1,000,000원</div>*/}
                    {/*</div>*/}
                    <div className="reparing">
                        <div className="icon"></div>
                        <div className="txt">준비중입니다!</div>
                    </div>
                </div>
            </div>
        );
    }
}
